import { Stack, useTheme } from "@mui/system";
import useStyles from "./styles";
import { useNavigate } from "react-router-dom";
import {
  Typography,
  Alert,
  Snackbar,
  Box,
  Avatar,
  Tooltip,
  IconButton,
  Paper,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Button,
  InputAdornment,
  TextField,
  Chip,
  List,
  ListItem,
  Divider,
  Pagination,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import apiCliente from "../../../../services/apiCliente";
import {
  Person,
  PersonOff,
  AccessTimeFilled,
  Settings,
  Edit,
  Delete,
  LockReset,
  Add,
  Search,
  Clear,
  MoreVert,
  FilterAltOutlined,
  PersonAddAlt1Outlined,
} from "@mui/icons-material";
import ModalAddUserCliente from "../ModalAddUserCliente";
import ModalEditUserCliente from "../ModalEditUserCliente";
import ModalEditSenha from "../ModalEditSenha";
import DatagridComponent from "../../../../components/datagridComponent";
import InternoModalConfirmacaoSaida from "../../../../components/modalSaindoDaPagina";
import dayjs from "dayjs";
import FilterBar from "../../../../components/topBarFilter";

export default function AdminUsuarioCliente() {
  const [userCliente, setUserCliente] = useState([]);
  const [loading, setLoading] = useState(true);
  const [snackbar, setSnackbar] = useState(null);
  const [selectedRow, setSelectedRow] = useState({});
  const [anchorEl, setAnchorEl] = useState(null);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [loadingDelete, setLoadingDelete] = useState(false);
  const [buscarUsuario, setBuscarUsuario] = useState("");
  const [idCliente, setIdCliente] = useState("");
  const [openModalAddUser, setOpenModalAddUser] = useState(false);
  const [openModalEditUser, setOpenModalEditUser] = useState(false);
  const [openModalEditSenha, setOpenModalEditSenha] = useState(false);
  const [windowWith, setWindowWith] = useState(window.innerWidth);

  const [createButton, setCreateButton] = useState(false);
  const [permissoes, setPermissoes] = useState([]);
  // Grupo econômico: define se exibe a coluna "Empresas" na listagem
  const [empresasGrupo, setEmpresasGrupo] = useState({
    isGrupo: false,
    membros: [],
  });

  const [userEdit, setUserEdit] = useState({
    id: "",
    nome: "",
    sobrenome: "",
    login: "",
    email: "",
    status: "",
    foto: "",
  });
  const [newUserCliente, setNewUserClient] = useState({
    login: "",
    email: "",
    senha: "",
  });
  const navigate = useNavigate();
  const open = Boolean(anchorEl);
  const theme = useTheme();
  const styles = useStyles(theme);
  const deleteBody =
    "O usuário será excluido permanentemente. Deseja realmente excluir o usuário?";
  const confirmDelete = "Excluir";
  const filteredRows = userCliente?.filter((row, index) => {
    row.numero = index;

    return (
      row.login?.toLowerCase()?.includes(buscarUsuario?.toLowerCase()) ||
      row.nome?.toLowerCase()?.includes(buscarUsuario?.toLowerCase()) ||
      row.email?.toLowerCase()?.includes(buscarUsuario?.toLowerCase()) ||
      row.sobrenome?.toLowerCase()?.includes(buscarUsuario?.toLowerCase()) ||
      row.codigoPermissao?.toLowerCase()?.includes(buscarUsuario?.toLowerCase())
    );
  });

  useEffect(() => {
    let result = JSON.parse(localStorage.getItem("userCliente"));

    setIdCliente(result?.usuarioCliente?.clienteId);
    if (result) {
      getUserClient(result?.usuarioCliente?.clienteId);
    }
    getPermissoes();
    getEmpresasGrupo();
    handleUsuarioId();

    if (handleUsuarioId() === false) {
      navigate("/login");
    }

    const handleResize = () => {
      setWindowWith(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
  }, []);

  const handleUsuarioId = () => {
    let result = JSON.parse(localStorage.getItem("userCliente"));
    // Verifica se a propriedade rlPermissoesUsuario existe e é um array
    if (Array.isArray(result?.usuarioCliente?.RlPermissoesUsuarioCliente)) {
      // Itera sobre o array para verificar se algum objeto contém a propriedade codigoPermissao com valor "ADM"
      for (let permissao of result?.usuarioCliente
        ?.RlPermissoesUsuarioCliente) {
        if (permissao?.permissao?.codigoPermissao.toUpperCase() === "ADM") {
          return true;
        }
      }
      return false;
    }
  };

  const getUserClient = async (clienteId) => {
    try {
      const response = await apiCliente.post("/findUserClientes", {
        idCliente: clienteId,
      });

      setUserCliente(response?.data);
    } catch (error) {
      setSnackbar({
        children: "Error: Não foi possivel se conectar ao servidor",
        severity: "error",
      });
    } finally {
      setLoading(false);
    }
  };
  async function getPermissoes() {
    try {
      const response = await apiCliente.get("/getPermissoesCliente");

      setPermissoes(response?.data);
    } catch (error) {
      console.error("Erro ao puxar permissões dos clientes");
    } finally {
    }
  }

  async function getEmpresasGrupo() {
    try {
      const response = await apiCliente.post("/cliente/find/empresasGrupo");

      setEmpresasGrupo({
        isGrupo: !!response?.data?.isGrupo,
        membros: response?.data?.membros || [],
      });
    } catch (error) {
      console.error("Erro ao buscar empresas do grupo econômico");
    }
  }

  const createUserCliente = async () => {
    try {
      let permissaoId = permissoes.filter(
        (permissao) => permissao?.codigoPermissao === newUserCliente?.permissao,
      );
      // Grupo econômico: restrição de empresas visíveis (ADM sempre vê tudo)
      const empresaIds =
        (newUserCliente?.permissao !== "ADM" &&
          Array.isArray(newUserCliente?.empresaIds) &&
          newUserCliente?.empresaIds) ||
        [];

      const response = await apiCliente.post("/createUserCliente", {
        login: newUserCliente?.login,
        senha: newUserCliente?.senha,
        email: newUserCliente?.email,
        clienteId: idCliente,
        permissaoId: (Array.isArray(permissaoId) && permissaoId[0]?.id) || "",
        ...(empresaIds.length > 0 ? { empresaIds } : {}),
      });
      setOpenModalAddUser(false);

      setUserCliente((prev) => [
        ...prev,
        {
          ...response?.data,
          permissoes: { permissaoId: permissaoId[0]?.id } || "",
          empresas:
            response?.data?.empresas ||
            (empresaIds.length > 0
              ? (newUserCliente?.empresasSelecionadas || []).map((empresa) => ({
                  id: empresa?.id,
                  nome: empresa?.nome || "",
                }))
              : []),
        },
      ]);
      setNewUserClient({
        login: "",
        email: "",
        senha: "",
        permissao: "",
      });
      setSnackbar({
        children: "Usuário criado com sucesso!",
        severity: "success",
      });
    } catch (error) {
      let menssegeErro = error?.response?.data.error;
      if (menssegeErro === "Email already exists!") {
        setSnackbar({
          children: "E-mail existente",
          severity: "error",
        });
      } else if (menssegeErro === "User already exists!") {
        setSnackbar({
          children: "Usuário existente",
          severity: "error",
        });
      } else {
        setSnackbar({
          children: "Error: Não foi possivel se conectar ao servidor",
          severity: "error",
        });
      }
    } finally {
      setCreateButton(false);
    }
  };

  const deleteUserClient = async (idUserCliente) => {
    setLoadingDelete(true);
    try {
      const response = await apiCliente.post("/deleteUserCliente", {
        idUserCliente: idUserCliente,
      });
      setOpenDeleteModal(false);
      const userClientes = userCliente.filter(
        (userCliente) => userCliente?.id !== idUserCliente,
      );
      setUserCliente(userClientes);
      setSnackbar({
        children: "Usuário excluído com sucesso!",
        severity: "success",
      });
    } catch (error) {
      setSnackbar({
        children: "Error: Não foi possivel se conectar ao servidor",
        severity: "error",
      });
    } finally {
      setLoadingDelete(false);
    }
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const columns = [
    {
      field: "avatar",
      headerName: "",
      maxWidth: 70,
      minWidth: 70,
      flex: 1,
      sortable: false,

      renderCell: (params) => {
        const foto = params?.row?.foto ? params?.row?.foto : "";
        return (
          <Box sx={styles.containerFotoUser}>
            <Avatar
              sx={styles.containerAvatar}
              alt={params.row.foto ? params.row.nome : ""}
              src={foto ? foto : "/"}
            />
          </Box>
        );
      },
    },
    {
      field: "login",
      headerName: "Login",
      width: 60,
      minWidth: 100,
      cellClassName: "centered-cell",
      flex: 1,
    },
    {
      field: "nome",
      headerName: "Nome",
      width: 80,
      minWidth: 100,
      cellClassName: "centered-cell",
      flex: 1,
      renderCell: (params) => {
        return `${params?.row?.nome || ""} ${params?.row?.sobrenome || ""}`;
      },
    },
    {
      field: "email",
      headerName: "E-mail",
      width: 60,
      minWidth: 120,
      flex: 1,
      cellClassName: "centered-cell",
      valueGetter: (params) => {
        return `${params || ""}`;
      },
    },
    {
      field: "permissoes",
      headerName: "Permissões",
      width: 40,
      minWidth: 100,
      flex: 1,
      cellClassName: "centered-cell",
      valueGetter: (params) => {
        return params?.permissaoId;
      },
      renderCell: (params) => {
        return (
          <>
            {params?.row?.permissoes?.permissaoId ? (
              Array.isArray(permissoes) &&
              permissoes
                ?.filter(
                  (permissao) =>
                    permissao?.id === params?.row?.permissoes?.permissaoId,
                )
                ?.map((perm, index) => (
                  <Tooltip title={perm?.codigoPermissao?.toUpperCase()}>
                    <Box sx={styles.conatinerChip}>
                      <Chip
                        key={index}
                        label={perm?.codigoPermissao?.toUpperCase()}
                        size="small"
                        sx={
                          perm?.codigoPermissao?.toUpperCase() === "ADM"
                            ? {
                                ...styles.chipPermissoes,
                                backgroundColor: "chip.main.waitingReview",
                              }
                            : {
                                ...styles.chipPermissoes,
                                backgroundColor:
                                  perm?.color ||
                                  theme.palette.colors.gray.medium,
                              }
                        }
                      />
                    </Box>
                  </Tooltip>
                ))
            ) : (
              <Tooltip title={"SEM PERMISSÃO"}>
                <Box sx={styles.conatinerChip}>
                  <Chip
                    label={"SEM PERMISSÃO"}
                    size="small"
                    sx={{
                      ...styles.chipPermissoes,
                      backgroundColor: "chip.main.arquive",
                    }}
                  />
                </Box>
              </Tooltip>
            )}
          </>
        );
      },
    },
    // Grupo econômico: empresas visíveis para o usuário
    ...(empresasGrupo?.isGrupo
      ? [
          {
            field: "empresas",
            headerName: "Empresas",
            width: 60,
            minWidth: 140,
            flex: 1,
            cellClassName: "centered-cell",
            valueGetter: (params) => {
              return Array.isArray(params) && params.length > 0
                ? params.map((empresa) => empresa?.nome).join(", ")
                : "Todas";
            },
            renderCell: (params) => {
              const empresas = params?.row?.empresas;
              const nomes =
                Array.isArray(empresas) && empresas.length > 0
                  ? empresas.map((empresa) => empresa?.nome).join(", ")
                  : "Todas";
              return (
                <Tooltip title={nomes}>
                  <Typography noWrap variant="body2">
                    {nomes}
                  </Typography>
                </Tooltip>
              );
            },
          },
        ]
      : []),
    {
      field: "status",
      headerName: "Status",
      width: 40,
      minWidth: 70,
      flex: 1,
      valueGetter: (params) => {
        return params;
      },
      renderCell: (params) => {
        return (
          <>
            {params?.row?.status === 1 && params?.row?.ultimoAcesso ? (
              <Box sx={styles.containerPrimeiroAcesso}>
                <Tooltip title="Perfil ativo">
                  <Person sx={styles.person} />
                </Tooltip>
              </Box>
            ) : !params?.row?.status ? (
              <Box sx={styles.containerPrimeiroAcesso}>
                <Tooltip title="Perfil desativado">
                  <PersonOff
                    sx={{ color: theme.palette.chip.colorText.critical }}
                  />
                </Tooltip>
              </Box>
            ) : params?.row?.status === 1 && !params?.row?.ultimoAcesso ? (
              <Box sx={styles.containerPrimeiroAcesso}>
                <Tooltip title="Aguardando primeiro login">
                  <Box>
                    <Person sx={styles.personOff} />
                    <AccessTimeFilled sx={styles.containerIconTime} />
                  </Box>
                </Tooltip>
              </Box>
            ) : (
              <></>
            )}
          </>
        );
      },
    },
    {
      field: "ultimoAcesso",
      headerName: "Último Acesso",
      width: 60,
      minWidth: 120,
      cellClassName: "centered-cell",
      flex: 1,
      valueGetter: (params) => {
        return (params?.createAt && dayjs(params?.createAt).toDate()) || "";
      },
      renderCell: (params) => {
        return (
          params?.row?.ultimoAcesso?.createAt &&
          dayjs(params?.row?.ultimoAcesso?.createAt).format("DD/MM/YYYY HH:mm")
        );
      },
    },

    {
      field: "detalhes",
      headerName: "Detalhes",
      maxWidth: 90,
      minWidth: 90,
      flex: 1,
      sortable: false,

      renderCell: (params) => {
        return (
          <Tooltip title="Visualizar perfil">
            <IconButton
              onClick={(event) => {
                setAnchorEl(event.currentTarget);
                setSelectedRow(params.row);
              }}
              id="basic-button"
              disabled={
                JSON.parse(localStorage.getItem("userCliente"))?.usuarioCliente
                  ?.id === params.row.id
              }
            >
              <Settings
                mode="view"
                params={params}
                sx={{
                  color:
                    JSON.parse(localStorage.getItem("userCliente"))
                      ?.usuarioCliente?.id === params.row.id
                      ? theme.palette.mode === "dark"
                        ? "chip.main.arquive"
                        : "disabled.main"
                      : theme.palette.mode === "dark"
                        ? "disabled.main"
                        : "chip.main.arquive",
                }}
              />
            </IconButton>
          </Tooltip>
        );
      },
    },
  ];

  // MOBILE
  const paginate = (array, pageSize) => {
    const pageCount = Math.ceil(array.length / pageSize);
    return Array.from({ length: pageCount }, (_, index) =>
      array.slice(index * pageSize, (index + 1) * pageSize),
    );
  };
  const [currentPage, setCurrentPage] = useState(1);

  const pageSize = 10;
  const paginatedRows = paginate(filteredRows, pageSize);
  const mobileRows = paginatedRows[currentPage - 1];

  const [openFilter, setOpenFilter] = useState(false);
  const actions = [
    {
      icon: <FilterAltOutlined />,
      name: "Filtro",
      onClick: () => setOpenFilter(true),
    },
    {
      icon: <PersonAddAlt1Outlined />,
      name: "Novo Usuário",
      onClick: () => setOpenModalAddUser(true),
    },
  ];

  return (
    <Box sx={styles.container}>
      {/**F I L T R O S */}
      <FilterBar
        actions={actions}
        selectorComponentLeft={
          <TextField
            variant="outlined"
            label="Buscar usuário"
            value={buscarUsuario}
            size="small"
            onChange={(event) => {
              setBuscarUsuario(event.target.value);
            }}
            sx={{
              ...styles.searchField,
              width: "100%",
              maxWidth: 500,
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Search />
                </InputAdornment>
              ),
              endAdornment: buscarUsuario ? (
                <InputAdornment position="end">
                  <IconButton onClick={() => setBuscarUsuario("")} edge="end">
                    <Clear />
                  </IconButton>
                </InputAdornment>
              ) : null,
            }}
          />
        }
        selectorComponentRight={
          <Button
            startIcon={<Add sx={styles.containerAdd} />}
            onClick={() => setOpenModalAddUser(true)}
            variant="outlined"
            sx={{
              color: theme.palette.text.main,
              borderColor: theme.palette.text.main,
              maxWidth: "150px",
            }}
          >
            Novo Usuário
          </Button>
        }
        windowWidth={30000}
        openFilter={openFilter}
        setOpenFilter={setOpenFilter}
        type={0}
      />
      <Paper
        sx={{
          ...styles.paper,
          ...(filteredRows?.length > 16 && { height: "500px" }),
        }}
        elevation={theme.palette.mode === "dark" ? 0 : 3}
      >
        {/* 
				{windowWith < 1130 ? (
					<Box>
						<List
							sx={{
								display: "flex",
								flexDirection: "column",
								maxWidth: "100%",
							}}
						>
							{Array.isArray(mobileRows) &&
								mobileRows?.map((row, index) => (
									<ListItem sx={styles.listItem}>
										<Divider component="li" sx={{ width: "100%" }} />
										<Box sx={styles.rowListMobile}>
											<Box sx={styles.itemContentMobile}>
												<Box
													sx={{
														...styles.contentRowMobile,
														flexWrap: "nowrap",
													}}
												>
													<Typography variant="mySubtitle">
														{row?.nome ? row?.nome + " " + row?.sobrenome : ""}
													</Typography>

                          {row?.permissoes?.permissaoId ? (
                            Array.isArray(permissoes) &&
                            permissoes
                              .filter(
                                (permissao) =>
                                  permissao?.id === row?.permissoes?.permissaoId
                              )
                              .map((perm, index) => (
                                <Chip
                                  key={index}
                                  label={perm?.codigoPermissao?.toUpperCase()}
                                  sx={
                                    perm?.codigoPermissao?.toUpperCase() ===
                                    "ADM"
                                      ? {
                                          ...styles.chipPermissoes,
                                          backgroundColor:
                                            "chip.main.waitingReview",
                                          width: "101px",
                                        }
                                      : {
                                          ...styles.chipPermissoes,
                                          backgroundColor:
                                            "chip.main.waitingReturn",
                                          width: "101px",
                                        }
                                  }
                                />
                              ))
                          ) : (
                            <Chip
                              label={"TÉCNICO"}
                              sx={{
                                ...styles.chipPermissoes,
                                backgroundColor: "chip.main.arquive",
                                width: "101px",
                              }}
                            />
                          )}
                        </Box>

												<Box sx={styles.contentRowMobile}>
													<Box sx={styles.mobileTextGroup}>
														<Typography
															sx={styles.opacityFieldMobile}
															variant="caption"
														>
															Login:
														</Typography>
														<Typography sx={styles.textContentMobile}>
															{row?.login}
														</Typography>
													</Box>
													<Box sx={styles.mobileTextGroup}>
														<Typography
															sx={styles.opacityFieldMobile}
															variant="caption"
														>
															E-mail:
														</Typography>
														<Typography
															sx={{
																...styles.textContentMobile,
																maxWidth: "230px",
																whiteSpace: "nowrap",
																overflow: "hidden",
																textOverflow: "ellipsis",
															}}
														>
															{row?.email}
														</Typography>
													</Box>
												</Box>
												<Box sx={styles.contentRowMobile}>
													<Box sx={styles.mobileTextGroup}>
														<Typography
															sx={styles.opacityFieldMobile}
															variant="caption"
														>
															Último acesso:
														</Typography>
														<Typography sx={styles.textContentMobile}>
															{row?.ultimoAcesso?.createAt &&
																dayjs(row?.ultimoAcesso?.createAt).format(
																	"DD/MM/YYYY HH:mm"
																)}
														</Typography>
													</Box>
													<Box sx={styles.mobileTextGroup}>
														<Typography
															sx={styles.opacityFieldMobile}
															variant="caption"
														>
															Status:
														</Typography>
														<Typography sx={styles.textContentMobile}>
															{row?.status === 1 && row?.ultimoAcesso
																? "Perfil ativo"
																: !row?.status
																? "Perfil desativado"
																: "Aguardando primeiro login"}
														</Typography>
													</Box>
												</Box>
											</Box>
											<IconButton
												sx={{
													bgcolor: "background.paper",
													borderRadius: 0,
													minHeight: "135px",
													":focus": {
														bgcolor: "background.paper",
													},
												}}
												onClick={(event) => {
													setAnchorEl(event.currentTarget);
													setSelectedRow(row);
												}}
											>
												<MoreVert />
											</IconButton>
										</Box>
									</ListItem>
								))}
							<Divider component="li" sx={{ width: "100%" }} />
						</List>
						<Box mt={2} display="flex" justifyContent="center">
							<Pagination
								count={paginatedRows.length}
								page={currentPage}
								onChange={(_, newPage) => setCurrentPage(newPage)}
							/>
						</Box>
					</Box>
				) : ( */}
        <Box
          sx={{
            display: "flex",
            ...(filteredRows?.length > 16 && { height: "445px" }),
          }}
        >
          <DatagridComponent
            rows={filteredRows}
            columns={columns}
            sxDatagrid={{
              "& .MuiDataGrid-row": {
                height: 40,
              },
              "& .centered-cell": {
                display: "flex",
                alignItems: "center",
              },
            }}
            // rowsPerPageOptions={[25, 50, 100]}
            // autoHeight={true}
            // pageSizeOptions={[25, 50, 100]}
            // initialState={{
            // 	pagination: {
            // 		paginationModel: { page: 1, pageSize: 25 },
            // 	},
            // }}
            // disableRowSelectionOnClick
            // sxDatagrid={styles.dataGrid}
            // disableColumnMenu
            // loading={loading}
          />
        </Box>
        {/* )} */}
      </Paper>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
        disableScrollLock={true}
      >
        <MenuItem
          onClick={() => {
            setAnchorEl(null);
            setOpenModalEditUser(true);
          }}
        >
          <ListItemIcon>
            <Edit />
          </ListItemIcon>
          <ListItemText>Editar</ListItemText>
        </MenuItem>
        <MenuItem
          onClick={() => {
            setAnchorEl(null);
            setOpenModalEditSenha(true);
          }}
        >
          <ListItemIcon>
            <LockReset />
          </ListItemIcon>
          <ListItemText>Alterar Senha</ListItemText>
        </MenuItem>
        <MenuItem
          onClick={() => {
            setOpenDeleteModal(true);
            setAnchorEl(null);
          }}
          disabled={loadingDelete}
        >
          <ListItemIcon sx={{ color: "error.main" }}>
            <Delete />
          </ListItemIcon>
          <ListItemText sx={{ color: "error.main" }}>Excluir</ListItemText>
        </MenuItem>
      </Menu>
      <InternoModalConfirmacaoSaida
        openConfirmacao={openDeleteModal}
        load={loadingDelete}
        setOpenConfirmacao={setOpenDeleteModal}
        execute={() => {
          deleteUserClient(selectedRow?.id);
        }}
        severity={"error"}
        title={"Atenção"}
        contentText={deleteBody}
        confirmText={confirmDelete}
      />
      <ModalAddUserCliente
        open={openModalAddUser}
        setOpenModalAddUser={setOpenModalAddUser}
        setNewUserClient={setNewUserClient}
        createUserCliente={createUserCliente}
        createButton={createButton}
        newUserCliente={newUserCliente}
        setSnackbar={setSnackbar}
        permissoes={permissoes}
      />
      <ModalEditUserCliente
        openModalEditUser={openModalEditUser}
        setOpenModalEditUser={setOpenModalEditUser}
        selectedRow={selectedRow}
        setUserEdit={setUserEdit}
        userEdit={userEdit}
        idCliente={idCliente}
        setSnackbar={setSnackbar}
        snackbar={snackbar}
        setUserCliente={setUserCliente}
        userCliente={userCliente}
        permissoes={permissoes}
      />
      <ModalEditSenha
        openModalEditSenha={openModalEditSenha}
        setOpenModalEditSenha={setOpenModalEditSenha}
        selectedRow={selectedRow}
        setUserEdit={setUserEdit}
        userEdit={userEdit}
        idCliente={idCliente}
        setSnackbar={setSnackbar}
        snackbar={snackbar}
        setUserCliente={setUserCliente}
        userCliente={userCliente}
        permissoes={permissoes}
      />

      {!!snackbar && (
        <Snackbar
          open
          onClose={() => setSnackbar(null)}
          autoHideDuration={2500}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        >
          <Alert {...snackbar} onClose={() => setSnackbar(null)} />
        </Snackbar>
      )}
    </Box>
  );
}
